// extracted by mini-css-extract-plugin
module.exports = {"root":"dlpTopLocations_root__wi53W","grid":"dlpTopLocations_grid__I6Urd"};